import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

interface Option {
  id: string | number;
  name: string;
  // value: string | number;
}



interface RadioGroupFieldProps {
  id: string;
  name: string;
  setValue: (name: string, value: any) => void;
  register?: UseFormRegister<any>;
  error?: FieldError | undefined;
  className?: string;
  options: Option[];
  onChange?: (value: string | number) => void;
  readOnly?: boolean;
}
const RadioGroupField: React.FC<RadioGroupFieldProps> = ({
  id,
  name,
  setValue,
  register,
  error,
  className,
  options,
  onChange,
  readOnly,
}) => {
  // var dat = setValue("genderType", 1);
  const registerData = register(name);

  return (
    <div className="form-group leading-6  flex ">
      {options?.length !== 0 ? (
        options?.map((option, i) => (
          <div key={i} className= "pr-4">
            <input
               id={`${id}-${option.id}`}
          
              type="radio"
              name={registerData.name}
              value={option?.id}
              // checked={selectedValue === option.id} // Check the radio button if it matches the selected value
              onChange={(e) => {
                if (onChange) {
                  onChange(e.target.value);
                }
                registerData.onChange(e);
              }}
              className={`${error ? "has-error" : ""} ${className}`}
              disabled={readOnly ? readOnly : undefined}
              ref={registerData.ref}
             
            />
            <label
              htmlFor={`${id}-${option.id}`}
              className={className ? className : "ml-2"}
            >
              {option.name}
            </label>
          </div>
        ))
      ) : (
        <></>
      )}
      {error && <div className="text-red-500 font-sm  text-[12px]">{error.message}</div>}
    </div>
  );
};
export default RadioGroupField;
